// removed by extract-text-webpack-plugin
module.exports = {"green":"iconHover__green___kEyNt fill-green--hover","blue":"iconHover__blue___3zdBk fill-blue--hover","white":"iconHover__white___3XLnj fill-white--hover","smoke":"iconHover__smoke___3bYH2 fill-smoke--hover","darkSmoke":"iconHover__darkSmoke___z0yGR fill-smoke--d--hover","extraDarkSmoke":"iconHover__extraDarkSmoke___26QAQ fill-smoke--xd--hover","silver":"iconHover__silver___l_8fE fill-silver--hover"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-button/Button/style/iconHover.css
// module id = 118
// module chunks = 0 2